import axios from 'axios';
import { TOKEN, IDUSUARIO } from '../constants';

const ENTREGAS_URL = process.env.REACT_APP_SID_ENTREGAS;

export default function(id, request) {
  const tipoCorreo = '5';
  const config = {
    params: {
      codigo: id,
    },
    headers: {
      idUsuario: IDUSUARIO,
      token: TOKEN,
    },
  };
  const data = {
    ...request,
    numeroPedidoVeh: id,
    tipoCorreo,
  };
  // http://172.20.200.45:8080/sid-entrega/entrega-vehiculo/pedidos/15.DJ7H013/autorizaciones
  return axios.post(`${ENTREGAS_URL}/entrega-vehiculo/pedidos/${id}/autorizaciones`, data, config);
}



// WEBPACK FOOTER //
// ./src/utils/postEntregasPaseAprogramacion.js